
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/alloy-wheels",
      function () {
        return require("private-next-pages/rims/alloy-wheels.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/alloy-wheels"])
      });
    }
  